<template id="eventview">
  <div class="container" id="event">
    <section>
      <div class="row" v-if="eventModel != null">
        <div class="col-lg-9 pr-lg-4">
          <!-- 活動內容 -->
          <div class="event-view section-group">
            <div class="card p-4">
              <h2 class="title mb-2">
                {{ eventModel.sgL_Title }}
              </h2>
              <div class="subrow mt-2">
                <div class="remark mt-1">
                  <span v-for="(type,index) in eventModel.sgL_TypeF" :key="index">{{type}}</span>
                  <span v-for="(type,index) in eventModel.sgL_NotesName" :key="index">{{type}}</span>
                </div>
                <ul class="action">
                  <!-- <li class="like" title="讚好">
                    <a href=""> <i class="far fa-thumbs-up mr-1"></i> 讚好 </a>
                  </li> -->
                  <!-- <li class="bookmark ml-4" title="收藏">
                    <a href=""> <i class="far fa-bookmark mr-1"></i> 收藏 </a>
                  </li> -->
                  <li class="share ml-4" :title=" $t('Activitys.Activeview.share')">
                    <a target="_blank"
                      :href="`https://www.facebook.com/sharer/sharer.php?src=sdkpreparse&amp;u=${shareurl}`"
                      style="color: #292c32" @click="addShareCount()">
                      <i class="fa fa-share mr-1"></i>  {{ $t('Activitys.Activeview.share') }}</a>
                  </li>
                  <!-- <li class="report ml-4" title="檢舉">
                    <a href=""> <i class="fa fa-flag mr-1"></i> 檢舉 </a>
                  </li> -->
                </ul>
              </div>
              <hr class="divider" />
              <ul class="event-detail-list">
                <li class="event-detail-item py-3">
                  <div class="data-title"><span> {{ $t('Activitys.Activeview.sgL_ActivityDatesF') }}</span></div>
                  <div class="data-content">
                    <span>{{ eventModel.sgL_ActivityDatesF }}</span>
                  </div>
                </li>
                <li class="event-detail-item py-3">
                  <div class="data-title"><span> {{ $t('Activitys.Activeview.sgL_Address') }}</span></div>
                  <div class="data-content">
                    <span>{{ eventModel.sgL_Address }}</span>
                  </div>
                </li>
                <li class="event-detail-item py-3" v-if="
                  eventModel.sgL_KMKeyworldF != null &&
eventModel.sgL_KMKeyworldF != ''">
                  <div class="data-title"><span> {{ $t('Activitys.Activeview.sgL_KMKeyworldF') }}</span></div>
                  <div class="data-content distance">
                    <span v-for="km in eventModel.sgL_KMKeyworldF" :key="km">{{
                      km
                    }}</span>
                  </div>
                </li>
                <li class="event-detail-item py-3">
                  <div class="data-title"><span> {{ $t('Activitys.Activeview.sgL_UnitTitle') }}</span></div>
                  <div class="data-content">
                    <span>{{ eventModel.sgL_UnitTitle }}</span>
                  </div>
                </li>
                <li class="event-detail-item py-3">
                  <div class="data-title"><span> {{ $t('Activitys.Activeview.sgL_StatusF') }}</span></div>
                  <div class="data-content">
                    <span>{{ eventModel.sgL_StatusF }}</span>
                  </div>
                </li>
                <li class="event-detail-item py-3">
                  <div class="data-title"><span> {{ $t('Activitys.Activeview.sgL_EndApplyDateF') }}</span></div>
                  <div class="data-content">
                    <span>{{ eventModel.sgL_EndApplyDateF }}</span>
                  </div>
                </li>
                <li class="event-detail-item py-3">
                  <div class="data-title"><span> {{ $t('Activitys.Activeview.sglActivityUrl') }}</span></div>
                  <div class="data-content">
                    <a :href="eventModel.sglActivityUrl" target="_blank">{{
                      eventModel.sglActivityUrl
                    }}</a>
                  </div>
                </li>
                <li class="event-detail-item py-3">
                  <div class="data-title"><span> {{ $t('Activitys.Activeview.sglActivityUrl2') }}</span></div>
                  <div class="data-content">
                    <a :href="eventModel.sglActivityUrl2" target="_blank">{{
                      eventModel.sglActivityUrl2
                    }}</a>
                  </div>
                </li>
              </ul>
              <div class="divider"></div>
              <div class="content mb-4" v-html="eventModel.sgL_Content">
                <!-- 注釋內容，v-html不需要內容 -->
                <!-- {{ eventModel.sgL_Content }} -->
              </div>
              <!-- <hr class="divider" />
              (這裡放 Facebook 留言插件)
              <a href="https://developers.facebook.com/docs/plugins/comments/"
                >https://developers.facebook.com/docs/plugins/comments/</a
              > -->
              <div>
                <hr class="divider" />
                <userCommentsVue :props_qryParams="commentsParams" ref="comment" @submitComment="submitComment"
                  @submitComment2="submitComment2"></userCommentsVue>
              </div>
            </div>
          </div>
          <!-- ./活動內容 -->
        </div>
        <div class="col-lg-3">
          <!-- 廣告 -->
          <div class="ad section-group">
            <div class="row">
              <div class="col-12">
                <ins class="adsbygoogle" style="display: inline-block; width: 300px; height: 250px"
                  data-ad-client="ca-pub-8370308321819212" data-ad-slot="7350126089"></ins>
              </div>
            </div>
          </div>
          <!-- ./廣告 -->

          <!-- 賽事相簿 -->
          <div class="event-album section-group">
            <h2 class="side-title"> {{ $t('Activitys.Activeview.EventAlbum') }}</h2>
            <div class="album-card card mb-1" v-for="photograph in eventModel.photoList" :key="photograph.id">
              <router-link :to="{
                name: 'albumviewPhotostream',
                query: {
                  id: photograph.id,
                },
              }">
                <div class="album-block">
                  <div class="album-thumbnail">
                    <div class="album-responsive">
                      <div class="album-sizer">
                        <div class="album-image" :style="{
                          backgroundImage:
                            'url(' + `${photograph.photoImage}` + ')',
                        }"></div>
                      </div>
                    </div>
                    <div class="album-photo-count">
                      <span>{{ photograph.sgL_PG_CPhotoQuantityF }}</span>
                    </div>
                  </div>
                </div>
                <div class="album-info px-3 py-2">
                  <div class="album-title mb-2" :title="photograph.sgL_PG_CName">
                    {{ photograph.sgL_PG_CName }}
                  </div>
                  <span class="album-user">{{
                    photograph.sgL_Mem_DisplayName
                  }}</span>
                </div>
              </router-link>
            </div>
          </div>
          <!-- /.賽事相簿 -->

          <!-- 日期相近的活動 -->
          <div class="nearday-event section-group">
            <h2 class="side-title"> {{ $t('Activitys.Activeview.msg') }}</h2>
            <div class="card p-3">
              <ul class="nearday-event-list">
                <li v-for="data in activeListByDate" :key="data.id">
                  <div class="event-title my-1">
                    <a href="#" @click="eventid = data.id">
                      {{ data.sgL_Title }}
                    </a>
                  </div>
                  <div class="event-info">
                    <span class="event-date mr-4">{{
                      data.sgL_EndActivityDateF
                    }}</span>
                    <span class="event-region">{{ data.sgL_CityF }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- /.日期相近的活動 -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import bases from "../../api/httpApi/base";
import userCommentsVue from "../common/userComments.vue";
export default {
  data() {
    return {
      base: null,
      shareurl: location.href,
      eventModel: null,
      eventid: null,
      activeListByDate: null,
      commentsParams: {
        SGL_PG_Coid: this.$route.params.id,
        SGL_Msg_Type: 3,
      },
    };
  },
  components: {
    userCommentsVue,
  },
  watch: {
    eventid(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.GetEvent();
      }
    },
    "eventModel.sgL_Title": {
      handler: function (newval, oldval) {
        document.title = newval + " - 尋寶網";
      },
    },
  },

  created() {
    this.base = bases;
    this.$store.dispatch("updateCurrentIndex", 3);
    this.eventid = this.$route.params.id;
    this.GetEvent();
    this.pageViews();
  },
  methods: {
    submitComment(data) {
      let params = {
        sgL_PG_CBigsort: this.eventModel.sgL_TypeId,
        sgL_PG_Coid: this.commentsParams.SGL_PG_Coid,
        sgL_Msg_Type: this.commentsParams.SGL_Msg_Type,
        sgL_Msg_MContent: data,
        sgL_Msg_SendType: 0,
        SGL_Mem_FinallyReceive_Cid: this.eventModel.sgL_UserId,
      };
      this.$refs.comment.submit(params);
    },
    submitComment2(
      data,
      sgL_Msg_ReplyMsgid,
      sgL_Mem_FinallyReceive_Cid,
      sgL_Mem_Reply_Cid
    ) {
      let params = {
        sgL_PG_CBigsort: this.eventModel.sgL_TypeId,
        sgL_PG_Coid: this.commentsParams.SGL_PG_Coid,
        sgL_Msg_Type: this.commentsParams.SGL_Msg_Type,
        sgL_Msg_MContent: data,
        sgL_Msg_ReplyMsgid: sgL_Msg_ReplyMsgid,
        sgL_Mem_FinallyReceive_Cid: sgL_Mem_FinallyReceive_Cid,
        sgL_Mem_Reply_Cid: sgL_Mem_Reply_Cid,
        sgL_Msg_SendType: 1,
      };
      this.$refs.comment.submit(params);
    },
    pageViews() {
      let params = {};
      params[this.eventid] = "10";
      this.$api.EventApi.pageViews(params);
    },
    addShareCount() {
      let params = {};
      params[this.eventid] = "50";
      this.$api.EventApi.pageViews(params);
    },
    GetNearAllListDesk() {
      let params = {
        SGL_ActivityDate: this.eventModel.sgL_ActivityDateA,
        MaxResultCount: 20,
      };
      this.$api.EventApi.GetNearAllListDesk(params).then((res) => {
        if (res.data.success) {
          this.activeListByDate = res.data.result.items;
        }
      });
    },

    GetEvent() {
      let params = {
        Id: this.eventid,
      };
      this.$api.EventApi.GetEventDesk(params).then((res) => {
        if (res.data.success) {
          this.eventModel = res.data.result;
          this.setMeta(this.eventModel);
          this.GetNearAllListDesk();
        }
      });
    },
    setMeta(model) {
      console.log(model);
      this.shareurl = escape(
        this.base.url + "/Home/facebookResp?id=" + model.id + "&type=Eventview"
      );
      console.log(this.shareurl);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Activitys/Activeview.vue